import { IconButton, Badge, Tooltip } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

// Small comment affordance shown next to a field in the entry editor.
// Shows the open-comment count for the field and opens the comments
// drawer scoped to it.
const FieldCommentBadge = ({ count = 0, onClick }) => (
  <Tooltip title={count > 0 ? `${count} open comment${count > 1 ? 's' : ''}` : 'Comment on this field'}>
    <IconButton
      size="small"
      onClick={onClick}
      sx={{ opacity: count > 0 ? 1 : 0.35, '&:hover': { opacity: 1 } }}
    >
      <Badge badgeContent={count} color="primary" max={99}>
        <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
      </Badge>
    </IconButton>
  </Tooltip>
);

export default FieldCommentBadge;
